import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { combineReducers } from 'redux'
import auth from './reducers/auth';
import questions from './reducers/questions';
import scoreboard from './reducers/scoreboard';
import content from './reducers/content';
import { connectRouter, routerMiddleware, LOCATION_CHANGE } from 'connected-react-router'
import { createBrowserHistory } from "history";
import {
	createForms
} from 'react-redux-form';
import { persistStore, persistReducer, createMigrate } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import GoogleAnalytics, { trackPageView } from '@redux-beacon/google-analytics';
import { createMiddleware } from 'redux-beacon';

const pageView = trackPageView(action => ({
	page: action.payload.location.pathname,
}));

const eventsMapper = (action) => {
	switch(action.type) {
		case LOCATION_CHANGE:
			return pageView;
		default:
			return [];
	}
}

const ga = GoogleAnalytics();
const gaMiddleware = createMiddleware(eventsMapper, ga);

let hist = createBrowserHistory({basename: '/'})

export const history = hist;

const initialState = {}
const enhancers = []
const middleware = [gaMiddleware, thunk, routerMiddleware(history)]

if (process.env.NODE_ENV === 'development') {
	const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

	if (typeof devToolsExtension === 'function') {
		enhancers.push(devToolsExtension({ trace: true, traceLimit: 25 }))
	}
}

const composedEnhancers = compose(
	applyMiddleware(...middleware),
	...enhancers
)

const rootReducer = combineReducers({
	...createForms({
		auth,
		questions
	}),
	scoreboard,
	content,
	router: connectRouter(history)
})

const migrations = {
	10: (state) => {
		return {
			...state,
			auth: {
				...state.auth,
				password_reset_token: null,
				loginError: null,
				passwordResetError: null
			},
			content: {
				...state.content,
				showPasswordModal: false,
				showPasswordResetToken: false
			}
		}
	}
}

const persistConfig = {
	key: 'root',
	storage,
	debug: true,
	whitelist: ['auth'],
	version: 10,
	migrate: createMigrate(migrations, { debug: true })
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default () => {
	const store = createStore(persistedReducer, initialState, composedEnhancers);
	return { store, persistor: persistStore(store) };
};